<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <el-container class="g-headless-common-ctn">
        <el-tabs tab-position="left" v-model="page" @tab-click="changePage">
          <el-tab-pane name="ksfxPage" label="考试分析" />
          <el-tab-pane name="stfxPage" label="试题分析" />
          <el-tab-pane name="examScore" label="考试成绩" />
        </el-tabs>

        <!-- <el-aside style="width: 150px; border-right:1px solid #e6e6e6">
          <el-tabs tab-position="left" v-model="page" @tab-click="changePage">
            <el-tab-pane name="ksfxPage" label="考试分析"></el-tab-pane>
            <el-tab-pane name="stfxPage" label="试题分析"></el-tab-pane>
            <el-tab-pane name="examScore" label="考试成绩"></el-tab-pane>
          </el-tabs>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main> -->
        <router-view></router-view>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
export default {
  data () {
    return {
      ksid: null,
      page: 'examScore'
    }
  },
  components: {
    myHeader
  },
  created () {
    this.ksid = this.$route.query.ksid
    const page = location.pathname.substr(location.pathname.lastIndexOf('/') + 1)
    if (page !== 'report') {
      this.page = page
    }
  },
  methods: {
    changePage () {
      const query = {
        ksid: this.ksid
      }
      this.$router.push({
        path: '/report/' + this.page,
        query: query
      })
    }
  }
}
</script>
